(function () {
  var p = document.getElementById('popup'); if (!p) return;
  var seen = false; try { seen = sessionStorage.getItem('pg:popup') === '1' || localStorage.getItem('pg:nl') === '1'; } catch (e) { }
  if (seen || p.querySelector('.stock.is-ok') || document.body.classList.contains('template-cart') || document.body.classList.contains('template-product') || document.body.classList.contains('template-customers-login')) return;
  function onScroll() {
    var h = document.documentElement.scrollHeight - innerHeight;
    if (h > 0 && scrollY / h > 0.6) {
      removeEventListener('scroll', onScroll);
      if (!document.querySelector('.drawer.is-open')) { p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false'); }
    }
  }
  addEventListener('scroll', onScroll, { passive: true });
})();
